import { AbilityBuilder } from "@casl/ability";

export default function (appEl) {
  let role = "user";
  if (appEl && appEl.attributes && appEl.attributes.role && appEl.attributes.role.value) {
    role = appEl.attributes.role.value;
  }
  switch (role.toLowerCase()) {
  case "inq-admin":
    return AbilityBuilder.define((can, cannot) => {
      can("create", "NewProcess"),
      can("manage", "ProcessTemplate"),
      cannot("manage", "Process"),
      cannot("customize", "ProcessTemplate"),
      cannot("customize", "Process"),
      can("notify", "change"),
      can("read", "ProcessTemplate");
    });
  case "inq-serviceadmin":
    return AbilityBuilder.define((can, cannot) => {
      can("create", "NewProcess");
      cannot("manage", "ProcessTemplate"),
      can("manage", "Process"),
      can("customize", "ProcessTemplate"),
      cannot("customize", "Process"),
      cannot("notify", "change"),
      can("read", "ProcessTemplate");
    });
  default:
    return AbilityBuilder.define((can, cannot) => {
      cannot("create", "NewProcess");
      cannot("manage", "ProcessTemplate"),
      cannot("manage", "Process"),
      cannot("customize", "ProcessTemplate"),
      cannot("customize", "Process"),
      cannot("notify", "change"),
      cannot("read", "ProcessTemplate");
    });
  }
}
